import Vue from 'vue'
import Router from 'vue-router'
import LayoutDefault from './layouts/LayoutDefault.vue'
import LayoutCustom from './layouts/LayoutCustom.vue'
import LayoutAdmin from './layouts/LayoutAdmin.vue'
import Home from './layouts/Home.vue'
import Login from './components/Login.vue'
import Profile from './components/users/Profile.vue'
import OrganizerProfile from './components/users/OrganizerProfile.vue'
import ChangePassword from './components/users/ChangePassword.vue'
import ConfirmUser from './components/users/ConfirmUser'
import ForgotPassword from './components/users/ForgotPassword'
import ResetPassword from './components/users/ResetPassword'
import UserGiftCardForm from './components/users/gift_cards/Form'
import UserEventsIndex from './components/users/events/Index'
import UserEventForm from './components/users/events/Form'
import UserEventShow from './components/users/events/Show'
import UserStaffersIndex from './components/users/staffers/Index'
import UserStafferForm from './components/users/staffers/Form'
import UserStafferAccount from './components/users/stripe/Show'
import SiteIntegrationForm from './components/users/site_integration/Form'
import EventsIndex from './components/events/Index'
import EventShow from './components/events/Show'
import GiftCardsIndex from './components/gift_cards/Index'
import GiftCardShow from './components/gift_cards/Show'
import GiftCardPurchase from './components/gift_cards/GiftCardPurchase'
import GiftCardPurchaseConfirmation from './components/gift_cards/GiftCardPurchaseConfirmation'
import TicketPurchase from './components/events/tickets/TicketPurchase'
import TicketPurchaseConfirmation from './components/events/tickets/TicketPurchaseConfirmation'
import ApplicationSettings from './components/users/admin/ApplicationSettings'
import IntegratedSites from './components/users/admin/IntegratedSites'
import AnalyticsForm from './components/users/analytics/Form'
import PrivacyPolicy from './components/PrivacyPolicy'

import CustomEventIndex from './components/events/custom/CustomEventIndex'
import CustomEventShow from './components/events/custom/CustomEventShow'
import CustomTicketPurchase from './components/events/custom/CustomTicketPurchase'
import CustomTicketPurchaseConfirmation from './components/events/custom/CustomTicketPurchaseConfirmation'
import CustomGiftCardShow from './components/gift_cards/custom/CustomGiftCardShow'
import CustomGiftCardPurchase from './components/gift_cards/custom/CustomGiftCardPurchase'
import CustomGiftCardPurchaseConfirmation from './components/gift_cards/custom/CustomGiftCardPurchaseConfirmation'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.VUE_BASE_URL,
  routes: [
    {
      path: '/',
      component: LayoutDefault,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: { requiresAuth: false }
        }
      ]
    },
    {
      path: '/',
      component: LayoutDefault,
      children: [
        {
          path: '/logout',
          name: 'logout',
          component: Home,
          meta: { requiresAuth: false }
        }
      ]
    },
    {
      path: '/authenticate',
      component: LayoutDefault,
      children: [
        {
          path: '/authenticate',
          component: Login,
          name: 'authenticate',
          meta: { requiresAuth: false }
        }
      ]
    },
    {
      path: '/privacy',
      component: LayoutDefault,
      children: [
        {
          path: '/privacy',
          component: PrivacyPolicy,
          name: 'privacyPolicy',
          meta: { requiresAuth: false }
        }
      ]
    },
    {
      path: '/users/confirmation',
      component: LayoutDefault,
      children: [
        {
          path: '/users/confirmation',
          component: ConfirmUser,
          meta: { requiresAuth: false },
          name: 'userConfirmation'
        }
      ]
    },
    {
      path: '/forgot-password',
      component: LayoutDefault,
      children: [
        {
          path: '/forgot-password',
          component: ForgotPassword,
          meta: { requiresAuth: false },
          name: 'forgotPassword'
        }
      ]
    },
    {
      path: '/reset-password',
      component: LayoutDefault,
      children: [
        {
          path: '/reset-password',
          component: ResetPassword,
          meta: { requiresAuth: false },
          name: 'resetPassword'
        }
      ]
    },
    {
      path: '/events',
      name: 'events',
      component: LayoutDefault,
      children: [
        {
          path: '/events',
          name: 'eventList',
          component: EventsIndex,
          meta: { requiresAuth: false }
        },
        {
          path: '/events/purchase-confirmation/:order_number',
          component: TicketPurchaseConfirmation,
          name: 'ticketPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/events/:id/tickets-purchase',
          component: TicketPurchase,
          name: 'ticketPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        },
        {
          path: '/events/:id/:event_title',
          name: 'eventShow',
          component: EventShow,
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        }
      ]
    },
    {
      path: '/gift-cards',
      name: 'giftCards',
      component: LayoutDefault,
      children: [
        {
          path: '/gift-cards',
          name: 'giftCardList',
          component: GiftCardsIndex,
          meta: { requiresAuth: false }
        },
        {
          path: '/gift-cards/purchase-confirmation/:order_number',
          component: GiftCardPurchaseConfirmation,
          name: 'giftCardPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/gift-cards/:id/gift-card-purchase',
          component: GiftCardPurchase,
          name: 'giftCardPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'GiftCard'
          }
        },
        {
          path: '/gift-cards/:id/:gift_card_title',
          name: 'giftCardShow',
          component: GiftCardShow,
          meta: {
            requiresAuth: false,
            modelType: 'GiftCard'
          }
        }
      ]
    },
    {
      path: '/users',
      name: 'user',
      component: LayoutAdmin,
      children: [
        {
          path: '/users/profile/my-profile',
          name: 'userProfile',
          component: Profile,
          meta: { requiresAuth: true }
        },
        {
          path: '/users/profile/organizer-profile',
          name: 'organizerProfile',
          component: OrganizerProfile,
          meta: { requiresAuth: true }
        },
        {
          path: '/users/profile/change-password',
          name: 'userChangePassword',
          component: ChangePassword,
          meta: { requiresAuth: true }
        },
        {
          path: '/users/gift_cards',
          name: 'createGiftCard',
          component: UserGiftCardForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/events',
          name: 'userEvents',
          component: UserEventsIndex,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/events/:id/details',
          name: 'showEvent',
          component: UserEventShow,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin'],
            modelType: 'Event'
          }
        },
        {
          path: '/users/events/:action',
          name: 'createEvent',
          component: UserEventForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/events/:action/:id',
          name: 'editEvent',
          component: UserEventForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin'],
            modelType: 'Event'
          }
        },
        {
          path: '/users/staffers',
          name: 'staffers',
          component: UserStaffersIndex,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/staffers/:action',
          name: 'stafferForm',
          component: UserStafferForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/stripe-account',
          name: 'stripeAccount',
          component: UserStafferAccount,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin', 'member']
          }
        },
        {
          path: '/users/site-integration',
          name: 'siteIntegrationForm',
          component: SiteIntegrationForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        },
        {
          path: '/users/analytics',
          name: 'analyticsForm',
          component: AnalyticsForm,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin', 'client_admin']
          }
        }
      ]
    },
    {
      path: '/',
      name: 'admin',
      component: LayoutAdmin,
      children: [
        {
          path: '/admin/application-settings',
          name: 'applicationSettings',
          component: ApplicationSettings,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin']
          }
        },
        {
          path: '/admin/sites-integration',
          name: 'IntegratedSites',
          component: IntegratedSites,
          meta: {
            requiresAuth: true,
            limitedAccess: true,
            authorizedRoles: ['admin']
          }
        }
      ]
    },
    {
      path: '/integration',
      name: 'integration',
      component: LayoutCustom,
      children: [
        {
          path: '/integration/:domain_name/events',
          name: 'customEventList',
          component: CustomEventIndex,
          meta: { requiresAuth: false }
        },
        {
          path: '/integration/:domain_name/events/purchase-confirmation/:order_number',
          component: CustomTicketPurchaseConfirmation,
          name: 'customTicketPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/integration/:domain_name/events/:id/tickets-purchase',
          component: CustomTicketPurchase,
          name: 'customTicketPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        },
        {
          path: '/integration/:domain_name/events/:id/:event_title',
          name: 'customEventShow',
          component: CustomEventShow,
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        },
        {
          path: '/integration/:domain_name/gift-cards',
          name: 'customGiftCardList',
          component: CustomGiftCardShow,
          meta: { requiresAuth: false }
        },
        {
          path: '/integration/:domain_name/gift-cards/purchase-confirmation/:order_number',
          component: CustomGiftCardPurchaseConfirmation,
          name: 'customGiftCardPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/integration/:domain_name/gift-cards/gift-card-purchase',
          component: CustomGiftCardPurchase,
          name: 'customGiftCardPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'GiftCard'
          }
        }
      ]
    },
    {
      // Not found route
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})
